import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../hooks/use-is-mobile';
import { breakPaymentKeywords } from '../../../utils/payment-autofill';

interface BatchNumberFieldProps {
  value: string;
  onChange: (value: string) => void;
  showError?: boolean;
}

export function BatchNumberField({ value, onChange, showError = false }: BatchNumberFieldProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const hasError = showError && value.trim() === '';

  return (
    <TextField
      label={breakPaymentKeywords(t('goodsReceiving.batchNumber'))}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      required
      autoComplete="off"
      name="lot-tracking-code"
      slotProps={{
        input: {
          name: 'lot-tracking-code',
          style: { fontSize: isMobile ? '16px' : undefined },
        },
      }}
      error={hasError}
      helperText={hasError ? t('goodsReceiving.batchNumberRequired') : undefined}
    />
  );
}
